module.exports = __webpack_public_path__ + "img/Notisphere_Logo_Color_Dark.4efa691d.png";